import React from "react";
import { ChangeEvent, Fragment } from "react";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";

import { Action, Location, UnregisterCallback } from "history";

import { V2 } from "../../Api";
import { formatDateTimeLocalNumericSeconds, /*formatName/, formatTimeLocal*/ } from "../../Utilities";
import withTitle from "../withTitle";

import ValidateInput from "../ValidateInput";


import "../../blocks.css";
import "../viewer.css";

interface IAuditLogViewState {
    changedFields: string[];
    isFilterOpen: boolean;
    isLoading: boolean | string;
    isTableLoading: boolean | string;

    endDate: string;
    endTime: string;
    startDate: string;
    startTime: string;

    action: string;
    ipAddress: string;
    itemType: string;
    userId: string;
    itemId: string;

    result: string;
    sortColumn: string;
    sortDirection: string;

    entries: any[];

    pageLimit: number;
    pageOffset: number;

    doInitialLoad: boolean;

    actions: any[];
    itemTypes: any[];
    users: any[];


    [name: string]: any;
}

const PAGE_SIZE = 100;

class AuditLogView extends React.Component<RouteComponentPropsHistory<any, any>, IAuditLogViewState> {
    private inputs: ValidateInput[];
    private historyListener?: UnregisterCallback;

    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        const state: IAuditLogViewState = {
            changedFields: [],
            isFilterOpen: true,
            isLoading: true,
            isTableLoading: false,

            endDate: "",
            endTime: "",
            startDate: "",
            startTime: "",

            action: "",
            ipAddress: "",
            itemType: "",
            userId: "",
            itemId: "",

            result: "",
            sortColumn: "",
            sortDirection: "",

            entries: [],

            pageLimit: PAGE_SIZE,
            pageOffset: 0,

            doInitialLoad: false,

            actions: [
                { id: "create", displayName: "Create" },
                { id: "read", displayName: "View" },
                { id: "write", displayName: "Edit" },
                { id: "delete", displayName: "Delete" }
            ],
            itemTypes: [
                { id: "auth", displayName: "Authentication" },
                { id: "employee", displayName: "Employee" },
                { id: "role", displayName: "Role" },
                { id: "user", displayName: "User" },
                { id: "location", displayName: "Location" },
                { id: "appointment", displayName: "Office Appointment" },
                { id: "fair", displayName: "Health Fair" },
                { id: "survey", displayName: "Questionnaire" },
                { id: "target_company", displayName: "Target Company" },
                { id: "device", displayName: "Device" },
                { id: "surgery", displayName: "Surgery" },
                { id: "surgery_glossary", displayName: "Surgery Glossary" },
                { id: "auditlog", displayName: "Audit Log" },
                { id: "bonus", displayName: "Bonuses" },
                { id: "task", displayName: "Task List" },
                { id: "files", displayName: "Uploaded Files" },
                { id: "schedule", displayName: "Schedule" },
                { id: "insurance_co", displayName: "Insurance Company" },
                { id: "metrics", displayName: "Metrics" },
                { id: "surveytype", displayName: "Questionnaire Type" },
                { id: "coverage", displayName: "Schedule Coverages" },
                { id: "consult", displayName: "Pellet Consultation" },
                { id: "forms", displayName: "Received Forms" },
                { id: "stmt", displayName: "Statements" },
                { id: "outreach", displayName: "Outreach" },
                { id: "msg", displayName: "Messaging" },
                { id: "remind", displayName: "Appointment Reminders" },
                { id: "email", displayName: "Email Message" },
                { id: "patient", displayName: "Patients" },
                { id: "document", displayName: "Surgical Documents" },
                { id: "datalist", displayName: "Data Lists" },
            ],
            users: [],
        };

        state.itemTypes.sort((a, b) => a.displayName.localeCompare(b.displayName));
        state.actions.sort((a, b) => a.displayName.localeCompare(b.displayName));

        if (props.location.state) {
            Object.assign(state, props.location.state);
            state.doInitialLoad = true;
        }

        this.state = state;

        this.formInputChanged = this.formInputChanged.bind(this);
        this.receiveValidationRef = this.receiveValidationRef.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
        this.loadEntries = this.loadEntries.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.handleHistoryChange = this.handleHistoryChange.bind(this);
        this.runFilter = this.runFilter.bind(this);

        this.inputs = [];
    }

    public async componentDidMount() {
        this.historyListener = this.props.history.listen(this.handleHistoryChange);

        try {
            const users = await V2.get<any[]>("users/summary");

            users.sort((a, b) => a.displayName.localeCompare(b.displayName));

            this.setState({
                isLoading: false,
                users
            });

            if (this.state.doInitialLoad) {
                this.loadEntries();
            }
        }
        catch (e) {
            this.setState({
                isLoading: e.message
            });
        }
    }

    public componentWillUnmount() {
        if (this.historyListener) {
            this.historyListener();
        }
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="spinner-center lds-dual-ring-big" />;
        }
        else if (typeof this.state.isLoading === "string") {
            return <span className="error-text">{this.state.isLoading}</span>;
        }

        let table;
        let tbody;

        if (this.state.isTableLoading === true) {
            tbody = <tr><td colSpan={10}><div className="spinner-center lds-dual-ring" /></td></tr>;
        }
        else if (typeof this.state.isTableLoading === "string") {
            tbody = <tr><td colSpan={10}><span className="error-text">{this.state.isTableLoading}</span></td></tr>;
        }
        else if (this.state.entries.length === 0) {
            tbody = (
                <tr>
                    <td colSpan={10}>No results</td>
                </tr>
            );
        }
        else {
            tbody = this.state.entries.map(a => (
                <tr key={a.timestamp + a.displayName}>
                    <td data-caption="Timestamp: " className="wrap">{formatDateTimeLocalNumericSeconds(a.timestamp)}</td>
                    <td data-caption="User: " className="wrap">{a.displayName ? a.displayName : "N/A"}</td>
                    <td data-caption="Action: ">{this.entryToAction(a)}</td>
                    <td data-caption="IP Address: " className="wrap">{a.ipAddress}</td>
                    <td data-caption="Status: " className="col-smallest col-center">{a.status === 0 ? <i className="icon-times red" title="Failed" /> : <i className="icon-check green" title="Success" />}<span className="text-only-copy">{a.status === 1 ? "Success" : "Failed"}</span></td>
                    <td data-caption="Source: " className="col-smallest col-center">{a.sourceId ? "Device" : "User"}</td>
                    <td data-caption="Ref: " className="col-smallest col-center"><span title={a.referrer}>{a.referrer ? <i className="icon-check" title={a.referrer} /> : null}</span><span className="text-only-copy">{a.referrer}</span></td>
                </tr>
            ));
        }

        table = <table className="table-vertical">
            <thead>
                <tr>
                    <th>Timestamp</th>
                    <th>User</th>
                    <th>Action</th>
                    <th>IP Address</th>
                    <th>Result</th>
                    <th>Source</th>
                    <th>Ref</th>
                </tr>
            </thead>
            <thead className="table-vertical-head-small">
                <tr>
                    <th>Audit Log</th>
                </tr>
            </thead>
            <tbody>
                {tbody}
            </tbody>
        </table>;

        return (
            <div className="viewer-root">
                {
                    !this.state.isFilterOpen
                        ? <div className="filter-control-box">
                            <div className="fill-space" />
                            <button type="button" className="button text-with-icon" onClick={this.toggleFilter}><i className="icon-filter" /><span>Filter</span></button>
                        </div>
                        : <form className="input-form">
                            <div className="column-root">
                                <section className="info-block">
                                    <header>
                                        <h3>Filter</h3>
                                    </header>

                                    <section>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-start-date">Start Date</label>
                                            <input type="date" id="frm-start-date" name="startDate" value={this.state.startDate} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-start-time">Start Time</label>
                                            <ValidateInput type="time" ref={this.receiveValidationRef} id="frm-start-time" name="startTime" value={this.state.startTime} onChange={this.formInputChanged} autoComplete="off_please_chrome" disabled={!this.state.startDate} />
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-end-date">End Date</label>
                                            <input type="date" id="frm-end-date" name="endDate" value={this.state.endDate} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-end-time">End Time</label>
                                            <ValidateInput type="time" ref={this.receiveValidationRef} id="frm-end-time" name="endTime" value={this.state.endTime} onChange={this.formInputChanged} autoComplete="off_please_chrome" disabled={!this.state.endDate} />
                                        </div>
                                    </section>
                                    <section>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-user">User</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-user" name="userId" value={this.state.userId} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Any</option>
                                                {this.state.users.map(a => <option key={a.id} value={a.id}>{a.displayName}</option>)}
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-action">Action</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-action" name="action" value={this.state.action} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Any</option>
                                                {this.state.actions.map(a => <option key={a.id} value={a.id}>{a.displayName}</option>)}
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-item-type">Type</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-item-type" name="itemType" value={this.state.itemType} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Any</option>
                                                {this.state.itemTypes.map(a => <option key={a.id} value={a.id}>{a.displayName}</option>)}
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-ip">IP Address</label>
                                            <ValidateInput type="text" ref={this.receiveValidationRef} id="frm-filter-ip" name="ipAddress" value={this.state.ipAddress} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                                        </div>
                                    </section>
                                    <section>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-sort-column">Sort By</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-sort-column" name="sortColumn" value={this.state.sortColumn} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Any</option>
                                                <option value="timestamp">Timestamp</option>
                                                <option value="user">User</option>
                                                <option value="action">Action</option>
                                                <option value="result">Result</option>
                                                <option value="ip">IP Address</option>
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-sort-direction">Sort Direction</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-sort-direction" name="sortDirection" value={this.state.sortDirection} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Default</option>
                                                <option value="asc">Ascending</option>
                                                <option value="desc">Descending</option>
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-result">Result</label>
                                            <ValidateInput type="select" ref={this.receiveValidationRef} id="frm-filter-result" name="result" value={this.state.result} onChange={this.formInputChanged} autoComplete="off_please_chrome">
                                                <option value="">Any</option>
                                                <option value="success">Success</option>
                                                <option value="failed">Failed</option>
                                            </ValidateInput>
                                        </div>
                                        <div className="input-form-group">
                                            <label htmlFor="frm-filter-itemid">Item ID</label>
                                            <ValidateInput type="text" ref={this.receiveValidationRef} id="frm-filter-itemid" name="itemId" value={this.state.itemId} onChange={this.formInputChanged} autoComplete="off_please_chrome" />
                                        </div>
                                    </section>
                                    <section className="action-panel-dialog">
                                        <button type="button" className="button text-with-icon push-right" onClick={this.runFilter}><i className="icon-filter" /><span>Apply</span></button>
                                        <button type="button" className="button" onClick={this.toggleFilter}>Close</button>
                                    </section>
                                </section>
                            </div>
                            &nbsp;
                        </form>
                }
                {table}
                &nbsp;
                <div className="action-panel action-panel-noflip">
                    <button className="button push-right text-with-icon" onClick={this.previousPage} disabled={this.state.pageOffset === 0}><i className="icon-angle-left" /><span>Previous</span></button>
                    <button className="button text-with-icon" onClick={this.nextPage} disabled={this.state.entries.length < PAGE_SIZE}><span>Next</span><i className="icon-angle-right" /></button>
                </div>
            </div>
        );
    }

    private receiveValidationRef(ref: ValidateInput) {
        this.inputs.push(ref);
    }


    private formInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>, callback?: (state: Partial<IAuditLogViewState>, prevState: IAuditLogViewState) => void) {
        let name = e.currentTarget.name;
        let value: string | boolean | any = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState(s => {
            const split = name.match(/(.+?):(.+)/);
            if (split) {
                // Array indexer
                name = split[1];
                const newValue = value;
                value = s[name] as any;

                const split2 = split[2].match(/(.+?):(.+)/);
                if (split2) {
                    value[split2[1]][split2[2]] = newValue;
                }
                else {
                    value[split[2]] = newValue;
                }
            }

            if (!s.changedFields.some(a => a === name)) {
                s.changedFields.push(name);
            }

            const newState = {
                changedFields: s.changedFields,
                hasChanged: true,
                [name]: value
            }


            if (name === "endDate" && !value) {
                newState.endTime = "";
            }
            if (name === "startDate" && !value) {
                newState.startTime = "";
            }

            if (callback) {
                const ns: any = {};
                Object.assign(ns, s);
                Object.assign(ns, newState);

                callback(newState, ns);
            }

            return newState;
        });
    }

    private toggleFilter() {
        this.setState(s => ({
            isFilterOpen: !s.isFilterOpen
        }), () => this.saveSearchState());
    }

    private runFilter() {
        this.setState({
            pageOffset: 0
        }, () => this.loadEntries());
    }

    private async loadEntries() {
        try {
            this.setState({
                isTableLoading: true
            });

            this.saveSearchState();

            const parameters = [
                `limit=${PAGE_SIZE}`,
                `offset=${this.state.pageOffset}`
            ];

            if (this.state.sortColumn) {
                parameters.push(`sort_by=${this.state.sortColumn}`);
            }
            if (this.state.sortDirection) {
                parameters.push(`sort_dir=${this.state.sortDirection}`);
            }
            if (this.state.userId) {
                parameters.push(`user=${this.state.userId}`);
            }
            if (this.state.action) {
                parameters.push(`action=${this.state.action}`);
            }
            if (this.state.itemType) {
                parameters.push(`type=${this.state.itemType}`);
            }
            if (this.state.ipAddress) {
                parameters.push(`ip=${encodeURIComponent(this.state.ipAddress)}`);
            }
            if (this.state.result) {
                parameters.push(`result=${this.state.result}`);
            }
            if (this.state.itemId) {
                parameters.push(`item_id=${this.state.itemId}`);
            }
            if (this.state.startDate) {
                let timestamp;
                if (this.state.startTime) {
                    timestamp = new Date(`${this.state.startDate}T${this.state.startTime}`);
                }
                else {
                    timestamp = new Date(`${this.state.startDate}T00:00:00`);
                }

                parameters.push(`after=${timestamp.toLocalISOString().replace("+", "%2B")}`);
            }
            if (this.state.endDate) {
                let timestamp;
                if (this.state.endTime) {
                    timestamp = new Date(`${this.state.endDate}T${this.state.endTime}`);
                }
                else {
                    timestamp = new Date(`${this.state.endDate}T00:00:00`);
                }

                parameters.push(`before=${timestamp.toLocalISOString().replace("+", "%2B")}`);
            }

            const entries = await V2.get<any[]>(`auditlog?${parameters.join("&")}`);

            this.setState({
                entries,
                isTableLoading: false,
            });
        }
        catch (e) {
            this.setState({
                isTableLoading: e.message
            });
        }
    }

    private handleHistoryChange(location: Location, action: Action) {
        if (action === "POP" && location.pathname.startsWith("/auditlog")) {
            this.loadEntries();
        }
    }

    private nextPage() {
        this.props.history.push(this.props.location);

        this.setState(s => {
            return {
                pageOffset: s.pageOffset + PAGE_SIZE
            };
        }, () => this.loadEntries());
    }

    private previousPage() {
        this.props.history.push(this.props.location);

        this.setState(s => {
            return {
                pageOffset: Math.max(s.pageOffset - PAGE_SIZE, 0)
            };
        }, () => this.loadEntries());
    }

    private saveSearchState() {
        const location = this.props.location;
        location.state = {
            pageLimit: this.state.pageLimit,
            pageOffset: this.state.pageOffset,

            action: this.state.action,
            endDate: this.state.endDate,
            endTime: this.state.endTime,
            ipAddress: this.state.ipAddress,
            isFilterOpen: this.state.isFilterOpen,
            itemId: this.state.itemId,
            itemType: this.state.itemType,
            sortColumn: this.state.sortColumn,
            sortDirection: this.state.sortDirection,
            startDate: this.state.startDate,
            startTime: this.state.startTime,
            userId: this.state.userId
        };

        this.props.history.replace(location);
    }

    private actionToString(action: number) {
        switch (action) {
            case 1: return "View";
            case 2: return "Edit";
            case 3: return "Create";
            case 4: return "Delete";
            default: return `Unknown (${action})`;
        }
    }

    private itemTypeToString(itemType: string) {
        switch (itemType) {
            case "employee": return "Employee";
            case "role": return "Permission Role";
            case "user": return "User";
            case "location": return "Office Location";
            case "appointment": return "Office Appointment";
            case "fair": return "Health Fair";
            case "survey": return "Questionnaire";
            case "target_company": return "Target Company";
            case "device": return "Device";
            case "surgery": return "Surgery";
            case "auth": return "Login";
            case "auditlog": return "Audit Log";
            case "surgery_glossary": return "Surgery Glossary";
            case "bonus": return "Bonuses";
            case "task": return "Task";
            case "files": return "Uploaded Files";
            case "schedule": return "Schedule";
            case "insurance_co": return "Insurance Company";
            case "metrics": return "Metrics";
            case "surveytype": return "Questionnaire Type";
            case "coverage": return "Schedule Coverage";
            case "consult": return "Pellet Consultation";
            case "forms": return "Received Forms";
            case "stmt": return "Statement";
            case "outreach": return "Outreach";
            case "msg": return "Messaging";
            case "remind": return "Appointment Reminders";
            case "email": return "Email";
            case "patient": return "Patient";
            case "document": return "Surgical Document";
            case "datalist": return "Data Lists";
            default: return `Unknown (${itemType})`;
        }
    }

    private itemToLink(itemType: string, subType: string, itemId: string) {
        switch (itemType) {
            case "employee": return `/employees/${itemId}`;
            case "role": return `/roles/${itemId}`;
            case "user": return `/users/${itemId}`;
            case "location": return `/locations/${itemId}`;
            case "appointment": return subType === "types"
                ? `/appointments/admin/${itemId}`
                : `/appointments/${itemId}`;
            case "fair": return `/fairs/${itemId}`;
            case "survey": return `/surveys/${itemId}`;
            case "target_company": return `/fairtargets/${itemId}`;
            case "device": return `/devices/${itemId}`;
            case "surgery": return `/surgery/${itemId}`;
            case "forms": return `/telemed/forms/${itemId}`;
            case "patient": return `/patient/${itemId}`;
            //case "document": return `/documents/${itemId}`; // Server can't find a patient from a document yet
            default: return "";
        }
    }

    private entryToAction(entry: any) {
        switch (entry.itemType) {
            case "surgery_glossary":
                return this.surgeryGlossaryToString(entry);
            case "metrics":
                return this.metricsToString(entry);
            case "forms":
                return this.formsToText(entry);
            case "employee":
            default:
                return <Fragment>{this.actionToString(entry.action)} {this.itemTypeToString(entry.itemType)}{!entry.itemId ? "(s)" : ""}{entry.subType ? ` ${entry.subType}` : ""} {entry.itemId ? <span className="text-only-copy">(ID: {entry.itemId})</span> : null} {entry.itemId && this.itemToLink(entry.itemType, entry.subType, entry.itemId) ? <Link to={this.itemToLink(entry.itemType, entry.subType, entry.itemId)} className="text-with-icon push-right print-hide"><span>View</span> <i className="icon-external-link" /></Link> : ""}</Fragment>
            case "auth":
                return (entry.action === 3 ? this.authSubTypeToString(entry.subType) : entry.action === 4 ? "Logout" : entry.action === 2 && entry.subType === "password" ? `Change password` : `Auth unknown (${entry.action})`);
        }
    }

    private authSubTypeToString(subType: string) {
        switch (subType) {
            case "token": return "Login using cached token";
            case "password": return "Login using password";
            default: return subType;
        }
    }

    private surgeryGlossaryToString(entry: any) {
        let typeName = "";
        let linkPrefix = "";
        switch (entry.subType) {
            case "surgery": typeName = "Surgery type"; linkPrefix = "/surgery/admin/surgerytype/"; break;
            case "device": typeName = "Surgical device"; break;
            case "drain": typeName = "Surgical drain"; break;
            case "specimen": typeName = "Surgical specimen"; break;
            default: break;
        }

        return <Fragment>{this.actionToString(entry.action)} {this.itemTypeToString(entry.itemType)} {typeName}{!entry.itemId ? "(s)" : ""} {entry.itemId ? <Link to={`${linkPrefix}${entry.itemId}`} className="text-with-icon push-right print-hide"><span>View</span> <i className="icon-external-link" /></Link> : ""}</Fragment>;
    }

    private metricsToString(entry: any) {
        let typeName = entry.subType;
        let linkPrefix = "";
        switch (entry.subType) {
            case "case-stats": typeName = "Case Stats"; break;
            case "marketing_dyn_s": typeName = "Marketing Stats"; break;
            case "marketing_dyn_l": typeName = "Location Stats"; break;
            case "marketing_dyn_c": typeName = "Marketing Completion Stats"; break;
            case "provider_dyn_a": typeName = "Provider Appointment Stats"; break;
            case "provider_dyn_s": typeName = "Provider Surgery Stats"; break;
            case "provider_st_a": typeName = "Provider Appointment Stats"; break;
            default: break;
        }

        return <Fragment>{this.actionToString(entry.action)} {this.itemTypeToString(entry.itemType)} {typeName}{!entry.itemId ? "(s)" : ""} {entry.itemId ? <Link to={`${linkPrefix}${entry.itemId}`} className="text-with-icon push-right print-hide"><span>View</span> <i className="icon-external-link" /></Link> : ""}</Fragment>;
    }

    private formsToText(entry: any) {
        let typeName = entry.subType;
        let linkPrefix = "/telemed/forms/";
        switch (entry.subType) {
            case "read": typeName = "Mark as Read"; break;
            case "unread": typeName = "Mark as Unread"; break;
            default: break;
        }

        return <Fragment>{this.actionToString(entry.action)} {this.itemTypeToString(entry.itemType)} {typeName}{!entry.itemId ? "(s)" : ""} {entry.itemId ? <Link to={`${linkPrefix}${entry.itemId}`} className="text-with-icon push-right print-hide"><span>View</span> <i className="icon-external-link" /></Link> : ""}</Fragment>;
    }
}

export default withTitle("Audit Log", AuditLogView);
